import { Skeleton } from 'antd'
import styles from './AnalyzingView.module.less'
import AnalysisStep from '../AnalysisStep/AnalysisStep'
import { useAnalysisLabels } from '../VideoAnalysis/VideoAnalysis'

interface Props {
  ratio: number
  notBegin?: boolean
}

function AnalyzingView({ ratio, notBegin }: Props) {
  const { ANALYSIS_LABELS } = useAnalysisLabels(true)
  return (
    <div className={styles.analyzingView}>
      <AnalysisStep notBegin={notBegin} ratio={ratio} labels={ANALYSIS_LABELS} style={{ marginBottom: 4 }} />
      {
        !notBegin &&
        <div className={styles.analyzingSkeleton}>
          <Skeleton.Input size='small' block style={{ width: '100%', height: 16 }} active />
          <Skeleton.Input size='small' block style={{ width: '100%', height: 16 }} active />
          <Skeleton.Input size='small' block style={{ width: '90%', height: 16 }} active />
          <Skeleton.Input size='small' block style={{ width: '10%', height: 16 }} active />
        </div>
      }
    </div>
  )
}

export default AnalyzingView
